import React from 'react';

const articleClass = (active: boolean): string =>
  active ? 'payment-box active' : 'payment-box';

interface IPaymentMethodProps {
  active: boolean;
  imgUrl: string;
  name: string;
  description: string;
  select: (name: string) => void;
}

export default function PaymentMethod(props: IPaymentMethodProps) {
  const { active, description, imgUrl, name, select } = props;
  const setMethod = () => select(name);

  return (
    <div className="col-12 col-sm-4 col-lg-4">
      <article
        className={articleClass(active)}
        onClick={setMethod}
        role="presentation"
      >
        <figure>
          <img
            className="d-flex mx-auto img-fluid"
            src={imgUrl}
            alt="Método de Pago"
          />
          <figcaption>{description}</figcaption>
        </figure>
      </article>
      <div className="w-100 d-sm-none mb20" />
    </div>
  );
}
